<div class="activity-scroll-container" (scroll)="onScroll($event)">
  <ng-container
    *ngIf="groupedActivities && (groupedActivities | keyvalue: dateDescOrder).length > 0; else emptyStateActivity">
    <ng-container *ngFor="let group of groupedActivities | keyvalue: dateDescOrder">
      <h3 class="date-header">{{ group.key }}</h3>
      <div class="activity-group">
        <div *ngFor="let activity of group.value" class="activity-item"
          [ngClass]="'activity-type-' + activity.activityType">

          <!-- Icon for activity -->
          <div class="icon-container">
            <span class="material-icons-outlined">
              {{ activity.isCompleted ? 'check_box' : getIconForActivity(activity.activityType) }}
            </span>
          </div>

          <!-- Content container -->
          <div class="content-container">
            <div class="header">
              <!-- Status chip if completed -->
              <span *ngIf="activity.isCompleted" class="status-chip completed">Completed</span>

              <!-- Metadata: updated by and relative time -->
              <span class="metadata">
                • {{ activity.updatedBy }} • {{ getRelativeTime(activity.createdDate) }}
                <span class="material-icons-outlined" (click)="openActivityActionModal(activity)" *ngIf="transcriptData"
                  style="font-size: 14px; vertical-align: text-bottom;cursor: pointer;">add</span>
              </span>

              <!-- Action buttons -->
              <!-- <div class="actions">
                <button [attr.guide]="sanitizedUrl + '-mark-complete-btn'" *ngIf="activity.status == 0"
                  class="action-btn">✓ Mark
                  complete</button>
                <button [attr.guide]="sanitizedUrl + '-add-outcome-btn'"
                  *ngIf="activity.activityType === 'task' || activity.activityType === 'meeting'" class="action-btn">Add
                  outcome
                </button>
                <button [attr.guide]="sanitizedUrl + '-reply-btn'" *ngIf="activity.activityType === 'email'"
                  class="action-btn">←
                  Reply</button>
                <button [attr.guide]="sanitizedUrl + '-more-options-btn'" class="more-options-btn">⋮</button>
              </div> -->
            </div>

            <!-- Notes and associations -->
            <div *ngIf="activity.activityType === 'Phone Call' 
                    || activity.activityType === 'OutboundCall'">

              <div *ngIf="activity.subject != activity.notes">
                {{activity.subject}}
              </div>

            </div>
            <div class="body">
              <p class="notes" style="margin-top: 10px;" [innerHTML]="activity.notes ? (activity.notes) : ''"></p>


              <div *ngIf="activity.schedule &&
                    (activity.activityType === 'Phone Call' 
                    || activity.activityType === 'OutboundCall')
                    " style="margin-top: 10px;">
                <div style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
                  <audio controls style="height: 38px; outline: none;">
                    <source [src]="getAudioUrl(activity.schedule)">
                  </audio>

                  <button class="btn btn-sm btn-primary" [disabled]="generatingAiMap[activity.id]"
                    (click)="generateAiAnalysis(activity)"
                    style="border-radius: 6px; padding: 6px 14px; font-weight: 500;">
                    <i class="fa fa-magic" *ngIf="!generatingAiMap[activity.id]"></i>
                    <i class="fa fa-spinner fa-spin" *ngIf="generatingAiMap[activity.id]"></i>
                    <span style="margin-left: 5px;">{{ generatingAiMap[activity.id] ? 'Generating AI...' :
                      ((activity.transcript || activity.callSummary || activity.report) ? 'Re-generate AI' : 'Generate
                      AI') }}</span>
                  </button>

                  <button *ngIf="activity.transcript || activity.callSummary || activity.report"
                    class="btn btn-sm btn-outline-info" (click)="viewReport(activity)"
                    style="border-radius: 6px; padding: 6px 14px; font-weight: 500;">
                    <i class="fa fa-file-text-o" style="margin-right: 5px;"></i> View AI Report
                  </button>
                </div>
              </div>

              <!-- Associated customer name -->
              <div style="margin-top: 10px;" *ngIf="activity.customerName" class="association">
                <span class="material-icons-outlined person-icon">person</span>
                <span>{{ activity.customerName }}</span>
              </div>

              <!-- Associated customer address -->
              <div style="margin-top: 10px;" *ngIf="activity.customerAddress" class="association">
                <span class="material-icons-outlined location-icon">place</span>
                <span>{{ activity.customerAddress }}</span>
              </div>

              <!-- HubSpot-Style Email Activity Card -->
              <!-- <div *ngIf="isEmailActivity(activity.activityType)" class="hubspot-email-card">
                <div class="hubspot-email-header" (click)="toggleEmailDetails(activity)">
                  <div class="header-left">
                    <span class="material-icons-outlined arrow-icon" [class.open]="activity.showEmailDetails">
                      chevron_right
                    </span>
                    <div class="email-badge">
                      <span class="material-icons-outlined">mail</span>
                    </div>
                    <div class="email-title-group">
                      <span class="activity-type-label">Email</span>
                      <span class="email-subject-heading">- {{ activity.subject || activity.emailSubject || 'Email Activity' }}</span>
                    </div>
                  </div>
                  <div class="header-right">
                    <span class="email-timestamp">{{ (activity.createdDate) | date:'MMM dd, yyyy h:mm a' }}</span>
                  </div>
                </div>

                <div class="hubspot-email-body" [@expandCollapse]="activity.showEmailDetails ? 'open' : 'closed'">
                  <div class="email-meta-bar">
                    <div class="sender-avatar">
                      <span class="material-icons-outlined">person</span>
                    </div>
                    <div class="sender-info">
                      <div class="sender-name-line">
                        <span class="sender-name">{{ activity.updatedBy || activity.fromEmail || 'Sender' }}</span>
                        <span class="recipient-to" *ngIf="activity.customerName || activity.toEmail">to {{ activity.customerName || activity.toEmail }}</span>
                      </div>
                      <div class="recipient-details" *ngIf="activity.fromEmail || activity.toEmail">
                        <span *ngIf="activity.fromEmail"><strong>From:</strong> {{ activity.fromEmail }}</span>
                        <span *ngIf="activity.toEmail" style="margin-left: 12px;"><strong>To:</strong> {{ activity.toEmail }}</span>
                      </div>
                    </div>
                    <div class="sent-tag">
                      <span class="badge-sent">Sent</span>
                    </div>
                  </div>

                  <div class="email-copy-info" *ngIf="activity.cc || activity.bcc">
                    <span *ngIf="activity.cc"><strong>CC:</strong> {{ activity.cc }}</span>
                    <span *ngIf="activity.bcc" style="margin-left: 12px;"><strong>BCC:</strong> {{ activity.bcc }}</span>
                  </div>

                  <div class="email-message-box" *ngIf="activity.emailBody || activity.notes">
                    <div class="email-message-content" [innerHTML]="activity.emailBody || activity.notes"></div>
                  </div>
                </div>
              </div> -->
            </div>


          </div>

        </div>
      </div>
    </ng-container>

    <div *ngIf="spinner" class="spinner">Loading more...</div>


  </ng-container>

  <!-- Empty state when no activities are present -->
  <ng-template #emptyStateActivity>
    <div class="empty-notes">
      <span class="material-icons-outlined empty-icon">event_note</span>
      <p>No activities yet. Use notes to capture talking points, action items, and ideas.</p>
    </div>
  </ng-template>
</div>

<!-- Content Modal Dialog -->
<ng-template #contentDialog>
  <div
    style="padding: 20px 24px; max-height: 80vh; display: flex; flex-direction: column; background-color: #ffffff; color: #212529; border-radius: 8px;">
    <!-- Modal Header -->
    <div
      style="display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #e9ecef; padding-bottom: 12px; margin-bottom: 16px;">
      <h4 style="margin: 0; font-weight: 700; color: #1e293b; font-size: 18px;">
        <i class="fa fa-magic" style="color: #6366f1; margin-right: 8px;"></i> AI Call Analysis & Report
      </h4>
      <i class="fa fa-times" (click)="closeModal()" mat-dialog-close
        style="font-size: 22px; color: #64748b; cursor: pointer; padding: 4px;" title="Close"></i>
    </div>

    <!-- Scrollable Content Body -->
    <div style="flex: 1; overflow-y: auto; padding-right: 4px;">
      <!-- Section 1: Call Summary -->
      <div *ngIf="selectedActivity?.callSummary"
        style="margin-bottom: 20px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 16px;">
        <h5
          style="margin-top: 0; margin-bottom: 8px; font-size: 15px; font-weight: 600; color: #0f172a; display: flex; align-items: center;">
          <i class="fa fa-align-left" style="color: #3b82f6; margin-right: 8px;"></i> Call Summary
        </h5>
        <div style="white-space: pre-wrap; font-size: 14px; color: #334155; line-height: 1.6;">
          {{ selectedActivity.callSummary }}
        </div>
      </div>

      <!-- Section 2: Call Transcript -->
      <div *ngIf="selectedActivity?.transcript"
        style="margin-bottom: 20px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 16px;">
        <h5
          style="margin-top: 0; margin-bottom: 8px; font-size: 15px; font-weight: 600; color: #0f172a; display: flex; align-items: center;">
          <i class="fa fa-file-text-o" style="color: #10b981; margin-right: 8px;"></i> Call Transcript
        </h5>
        <div
          style="white-space: pre-wrap; font-size: 13.5px; color: #334155; line-height: 1.6; max-height: 200px; overflow-y: auto; background: #ffffff; padding: 12px; border-radius: 6px; border: 1px solid #cbd5e1;">
          {{ selectedActivity.transcript }}
        </div>
      </div>

      <!-- Section 3: AI Executive Report -->
      <div *ngIf="selectedActivity?.report"
        style="margin-bottom: 12px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 16px;">
        <h5
          style="margin-top: 0; margin-bottom: 8px; font-size: 15px; font-weight: 600; color: #0f172a; display: flex; align-items: center;">
          <i class="fa fa-bar-chart" style="color: #8b5cf6; margin-right: 8px;"></i> AI Executive Report
        </h5>
        <div style="white-space: pre-wrap; font-size: 14px; color: #334155; line-height: 1.6;">
          {{ selectedActivity.report }}
        </div>
      </div>
    </div>

    <!-- Sticky Modal Footer -->
    <div
      style="display: flex; justify-content: flex-end; border-top: 1px solid #e2e8f0; padding-top: 12px; margin-top: 12px;">
      <button (click)="closeModal()" mat-dialog-close class="btn btn-secondary"
        style="padding: 6px 20px; font-weight: 500; border-radius: 6px; cursor: pointer;">Close</button>
    </div>
  </div>
</ng-template>